import { resolveRequestedAppLocale } from '@/i18n/eu-locales';
import { resolveReplyLocale } from '@/lib/locale';

export type AppLocales = Readonly<{
  /** All app chrome, settings, auth, dates, and accessibility labels. */
  interfaceLocale: string;
  /** Per-turn request locale hint; never dictates reply language. */
  replyLocale: string;
  /** Auth follows the same app-language setting. */
  authLocale: string;
}>;

/**
 * The saved app language owns the whole interface. Browser language is only
 * the fallback for Automatic. The per-turn request hint uses the same resolved
 * locale, while the model's response language remains governed by the per-turn
 * prompt policy.
 */
export function resolveAppLocales(
  configuredAppLocale: string | null | undefined,
  browserLocale: string | null | undefined,
): AppLocales {
  const interfaceLocale = resolveRequestedAppLocale(configuredAppLocale, browserLocale);
  const replyLocale = resolveReplyLocale(interfaceLocale, browserLocale);
  return {
    interfaceLocale,
    replyLocale,
    authLocale: interfaceLocale,
  };
}
